<template>
  <modal
    width="400px"
    :can-be-dismissed="false"
    ref="enterNameModal"
    :borderless="isMobile()"
    v-if="!getLocalUser()"
    :topMargin="isMobile() ? '150px' : ''"
    :hideFooter="true"
  >
    <template slot="header">
      <div class="order-type-header">
        <div class="card">
          <div class="card-body">
            <h3 class="card-title text-center">Please enter your name</h3>
            <form class="mt-5" @submit.prevent="handleSubmit(name)">
              <div class="form-group">
                <label for="name" class="text-dark">First Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  placeholder="John Kelly"
                  v-model="name"
                  @keypress="handleKeypress()"
                  @keyup="handleKeypress()"
                />
                <div
                  class="alert alert-danger mt-2"
                  role="alert"
                  v-show="error"
                >
                  {{ error }}
                </div>
              </div>
              <p
                id="terms"
                class="card-text text-center mt-5 ml-mr-3 text-muted"
              >
                By continuing you agree to our Terms and conditions
              </p>
              <button
                type="submit"
                class="btn btn-secondary btn-lg btn-block mt-5 rounded"
              >
                Start Ordering
              </button>
            </form>
          </div>
          <div
            class="card-footer text-center text-muted bg-transparent border-white"
          >
            <poweredby />
          </div>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import modal from "../modal.vue";
import poweredby from "../shared/poweredby.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "EnterName",
  components: {
    modal,
    poweredby,
  },
  data() {
    return {
      name: "",
      error: "",
    };
  },
  mounted() {
    if (this.$route.query) {
      const tableNumber =
        this.$route.query.table || sessionStorage.getItem("table");
      this.setTableNumber(tableNumber.toString());
      if (this.getUser) {
        this.name = this.getUser;
      }
    }
  },
  methods: {
    ...mapActions(["setTableNumber", "addUserToTable", "setSharedCartUser"]),
    handleSubmit(username) {
      if (
        this.getPeople.includes(username.trim()) &&
        username !== this.getUser
      ) {
        this.error = "Name already taken, choose another";
        return;
      }
      if (username) {
        this.addUserToTable(username);
        this.setSharedCartUser(username);
        this.$refs.enterNameModal.hideModal(true);
        return;
      }
      this.error = "Please enter your name";
    },
    handleKeypress() {
      this.error = "";
    },
    getLocalUser() {
      return localStorage.getItem("user") ? localStorage.getItem("user") : "";
    },
  },
  computed: {
    ...mapGetters(["getUser", "getPeople"]),
  },
};
</script>

<style></style>
